"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PARAMS_REQUIRE_BATCH_GET = exports.DEFAULT_ISSUES_SORT = exports.DEFAULT_ISSUES_OFFSET = exports.DEFAULT_ISSUES_LIMIT = exports.DEFAULT_ISSUES_FETCH_PARAMS = void 0;
var _sdk = require("../../../sdk");
const DEFAULT_ISSUES_LIMIT = exports.DEFAULT_ISSUES_LIMIT = 50;
const DEFAULT_ISSUES_OFFSET = exports.DEFAULT_ISSUES_OFFSET = 0;
const PARAMS_REQUIRE_BATCH_GET = exports.PARAMS_REQUIRE_BATCH_GET = ["viewable"];
const DEFAULT_ISSUES_SORT = exports.DEFAULT_ISSUES_SORT = {
  attribute: _sdk.IssueSortingField.DisplayId,
  direction: _sdk.IssueSortingDirection.Desc
};
const DEFAULT_ISSUES_FETCH_PARAMS = exports.DEFAULT_ISSUES_FETCH_PARAMS = {
  limit: DEFAULT_ISSUES_LIMIT,
  offset: DEFAULT_ISSUES_OFFSET,
  sortBy: DEFAULT_ISSUES_SORT,
  filterBy: {
    valid: true
  }
};
//# sourceMappingURL=defaultParams.js.map